export default function CtaSection() {
  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-24 bg-amber-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="space-y-12">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl h-96">
            <img
              alt="果園"
              className="w-full h-full object-cover object-top"
              src="https://public.readdy.ai/ai/img_res/f25358a5bfd303efa686dcbe902681d4.jpg"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent"></div>
          </div>
          <div className="text-center space-y-8">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight max-w-3xl mx-auto">
              讓我們攜手合作
              <br />
              將<span className="italic text-orange-700">新鮮</span>與
              <span className="italic text-orange-700">品質</span>帶給世界
            </h2>
            <button
              onClick={scrollToContact}
              className="px-10 py-4 bg-orange-700 text-white text-lg font-medium rounded-full hover:bg-orange-800 transition-all hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              開始合作
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
